module.exports = __webpack_public_path__ + "img/slide12.fa8c4e86.jpg";